// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import type { RequestOptions } from '@@/plugin-request/request';
import type { API } from './typings';

/**
 * Exchange Rates API Service
 */

export interface ExchangeRate {
  _id: string;
  currency: string;
  baseCurrency: string;
  rate: number;
  lastUpdatedBy?: {
    _id: string;
    name: string;
    email: string;
  };
  lastUpdatedByName?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ExchangeRateResponse {
  success: boolean;
  data?: {
    exchangeRate?: ExchangeRate;
    exchangeRates?: ExchangeRate[];
  };
  message?: string;
  errorCode?: string;
}

export interface UpdateExchangeRateParams {
  currency: string;
  rate: number;
}

export interface BulkUpdateExchangeRateParams {
  rates: UpdateExchangeRateParams[];
}

/** Get all exchange rates GET /api/v1/admin/exchange-rates */
export async function getAllExchangeRates(
  options?: RequestOptions,
): Promise<ExchangeRateResponse> {
  return request<ExchangeRateResponse>('/admin/exchange-rates', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Get exchange rate by currency GET /api/v1/admin/exchange-rates/:currency */
export async function getExchangeRateByCurrency(
  currency: string,
  options?: RequestOptions,
): Promise<ExchangeRateResponse> {
  return request<ExchangeRateResponse>(`/admin/exchange-rates/${currency}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** Update single exchange rate PUT /api/v1/admin/exchange-rates */
export async function updateExchangeRate(
  body: UpdateExchangeRateParams,
  options?: RequestOptions,
): Promise<ExchangeRateResponse> {
  return request<ExchangeRateResponse>('/admin/exchange-rates', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Update multiple exchange rates PUT /api/v1/admin/exchange-rates/bulk */
export async function bulkUpdateExchangeRates(
  body: BulkUpdateExchangeRateParams,
  options?: RequestOptions,
): Promise<ExchangeRateResponse> {
  return request<ExchangeRateResponse>('/admin/exchange-rates/bulk', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export interface ExchangeRateHistoryItem {
  date: string;
  rate: string;
  change: string;
}

export interface ExchangeRateHistoryResponse {
  success: boolean;
  data?: {
    history?: ExchangeRateHistoryItem[];
  };
  message?: string;
  errorCode?: string;
}

/** Get exchange rate history by currency GET /api/v1/admin/exchange-rates/:currency/history */
export async function getExchangeRateHistory(
  currency: string,
  options?: RequestOptions,
): Promise<ExchangeRateHistoryResponse> {
  return request<ExchangeRateHistoryResponse>(`/admin/exchange-rates/${currency}/history`, {
    method: 'GET',
    ...(options || {}),
  });
}


